import { Switch, Route } from 'react-router-dom';

export default function Routes({ routes }) {

  const routeComponents = routes.map(
    ({ path, component, exact, id }) => (
      <Route key={id} exact={exact} path={path}>
        {component}
      </Route>
    )
  );

  return <Switch>{routeComponents}</Switch>;
}
